export enum AudioType {
  moh = 'moh',
  greeting = 'greeting',
  name = 'name',
}
